import RestClient from './RestClient';
import Kpi from '../models/Kpi';
import KpiListResponse from '../models/KpiListResponse';
import CONFIG from '../config';
import CanEditResponse from "../models/CanEditResponse";

let Client = new RestClient({baseURL: CONFIG.API_URL});

export const KpiApi = {
  getNonEmptyFilter (filter) {
    let parts = [];
    for (let key in filter) {
      if (key == 'ids' && filter[key].length > 0) {
        filter[key].forEach(id => {
          parts.push('ids=' + id);
        });
      } else {
        if (filter[key].toString().length > 0) {
          parts.push(key + '=' + filter[key].toString());
        }
      }
    }
    return parts.join('&');
  },

  async getList (filter = {}) {
    try {
      const res = await Client.get('/api/v1/kpi?' + this.getNonEmptyFilter(filter));
      if (res.data) {
        if (res.data.content && res.data.content.forEach) {
          res.data.content.sort((left, right) => left.order - right.order);
        }
        return new KpiListResponse(res.data);
      } else {
        return new Error(res.data.message);
      }
    } catch (e) {
      return new Error(e.data.message);
    }
  },

  async getByUuid (uuid) {
    try {
      let params = new URLSearchParams({
        ids: uuid,
        page: 0,
        size: 1
      });
      const res = await Client.get('/api/v1/kpi?' + params.toString());
      if (res.data && res.data.content && res.data.content.length > 0) {
        return new Kpi(res.data.content[0]);
      } else {
        console.log('res', res);
        return new Kpi();
      }
    } catch (e) {
      console.log('error', e);
      return new Kpi();
    }
  },

  async create (data) {
    try {
      return await Client.post('/api/v1/kpi', data)
    } catch (e) {
      console.log('error', e);
      return e;
    }

  },

  async update (data) {
    try {
      return await Client.put('/api/v1/kpi/' + data.id, data)
    } catch (e) {
      console.log('error', e);
      return e;
    }

  },

  async delete (id) {
    try {
      return await Client.delete(`/api/v1/kpi/${id}`)
    } catch (e) {
      console.log('error', e);
      return e;
    }
  },

  async mark (id, action) {
    try {
      const res = await Client.get('/api/v1/kpi/' + id + '/mark?action=' + action);
      if (res.data) {
        return new CanEditResponse(res.data);
      } else {
        console.log('edit', id, res);
        return new CanEditResponse();
      }
    } catch (e) {
      console.log('error', e);
      return e;
    }
  },
  // MY
  async getKpiId (id) {
    const res = await Client.get(`/api/v1/kpi/${id}`)
    if (res.data) {
      return res
    } else {
      throw new Error(res.message)
    }
  },
  async changeMark (id, action) {
    return await Client.get('/api/v1/kpi/' + id + '/mark?action=' + action)
  },
  async updateData (data) {
    const res = await Client.put('/api/v1/kpi/' + data.id, data);
    return res?.data || false;
  },
  async createData (data) {
    const res = await Client.post('/api/v1/kpi', data)
    return res?.data || false
  },

  async downloadReport() {
    const res = await Client.get('/api/v1/report', {
      responseType: 'blob'
    })
    const nameFile = /filename\*?=([^']*'')?([^;]*)/.exec(res.headers['content-disposition'])
    if (res.data) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', decodeURI(nameFile[nameFile.length - 1])) // or any other extension
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    }
  }
};
